import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Smartphone, Bell, Globe, Monitor, MapPin } from "lucide-react";
export default function PartnerProgramCta() {
  const gridItems = [{
    type: 'image',
    src: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/partner_portrait_1.png',
    alt: 'Partner from Asia'
  }, {
    type: 'icon',
    icon: Smartphone,
    bgColor: 'bg-secondary',
    color: 'text-secondary-foreground'
  }, {
    type: 'image',
    src: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/partner_portrait_2.png',
    alt: 'Senior Partner'
  }, {
    type: 'icon',
    icon: Bell,
    bgColor: 'bg-primary',
    color: 'text-primary-foreground'
  }, {
    type: 'icon',
    icon: Globe,
    bgColor: 'bg-transparent',
    color: 'text-primary',
    isLarge: true
  }, {
    type: 'icon',
    icon: Monitor,
    bgColor: 'bg-primary',
    color: 'text-primary-foreground'
  }, {
    type: 'image',
    src: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/partner_portrait_3.png',
    alt: 'Partner from Middle East'
  }, {
    type: 'icon',
    icon: MapPin,
    bgColor: 'bg-secondary',
    color: 'text-secondary-foreground'
  }, {
    type: 'image',
    src: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/partner_portrait_4.png',
    alt: 'Partner from Africa'
  }];
  return;
}